import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { fetchQuizDataFromQuizId, findQuizList, findQuizzesInService } from 'pathfinder/api/quizzes';
import wikiFeaturedQuizPlacementHelper from './helpers/wikiFeaturedQuizPlacementHelper';
import { QuizConsumptionVariant } from 'pathfinder/rules-engine/modules/quizConsumptionModule';
import WikiDesktopFeaturedQuizModule from './modules/WikiDesktopFeaturedQuizModule';
import WikiMobileFeaturedQuizModule from './modules/WikiMobileFeaturedQuizModule';
import { ShowAds } from '../shared/QuizConsumption/components/Ads/_types';
import { isThemeDark } from 'utils/getWikiInfo';
import canDisplayAds from './helpers/canDisplayAds';
import getQuizIdFromUrlHash from './helpers/getQuizIdFromUrlHash';
import { setPageHaveQuiz } from 'pathfinder/modules/shared/QuizConsumption/utils/pushPageHaveQuizToWindow';
const getMediawikiCategories = (isDesktop) => {
    var _a, _b, _c, _d, _e;
    if (isDesktop) {
        const categoriesArr = Array.from((_b = (_a = document.querySelector('.categories')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('li')) !== null && _b !== void 0 ? _b : []);
        return categoriesArr.map((category) => { var _a; return (_a = category === null || category === void 0 ? void 0 : category.dataset) === null || _a === void 0 ? void 0 : _a.name; }).filter(Boolean);
    }
    const categoriesArr = Array.from((_d = (_c = document.querySelector('.article-footer-item ul')) === null || _c === void 0 ? void 0 : _c.querySelectorAll('li')) !== null && _d !== void 0 ? _d : []);
    return (_e = categoriesArr === null || categoriesArr === void 0 ? void 0 : categoriesArr.map((category) => category === null || category === void 0 ? void 0 : category.innerText).filter(Boolean)) !== null && _e !== void 0 ? _e : [];
};
export const getWikiQuizConsumptionModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    const isDesktop = moduleProps.config.variant === QuizConsumptionVariant.Desktop;
    const siteId = parseInt(window.SilverSurferSDK.getContext().current.productId, 10);
    // let's make sure we have data to show
    let quizzes = [];
    // first check if we have quiz id in hash - that means we prioritize it first
    const quizIdFromHash = getQuizIdFromUrlHash();
    if (quizIdFromHash) {
        const quiz = yield fetchQuizDataFromQuizId(quizIdFromHash);
        if (quiz) {
            log.debug('Found quiz in hash', quiz);
            quizzes.push(quiz);
        }
        else {
            log.error('Quiz with id from hash not found', quizIdFromHash);
        }
    }
    else {
        // fetch quizzes from service
        try {
            quizzes = yield findQuizzesInService(siteId, window.location.pathname, getMediawikiCategories(isDesktop));
            // filter out AI quizzes if we're not on an experiment
            // ignore if we force quizzes
            const AI_CREATOR_ID = '52905219';
            if (!isForced && quizzes.some((i) => i.creatorId === AI_CREATOR_ID)) {
                log.debug('GenAI quizzes found, removing from targeting', { quizzes });
                quizzes = quizzes.filter((i) => i.creatorId !== AI_CREATOR_ID);
            }
            log.debug('Quizzes from targeting', { quizzes });
        }
        catch (e) {
            log.error('Error fetching quizzes', e);
        }
    }
    if (quizzes.length < 1) {
        if (isForced) {
            // add fake quiz when forcing module - make sure we have something to show on production
            quizzes.push(yield fetchQuizDataFromQuizId(26));
        }
        else {
            // no quizzes found, nothing to display
            setPageHaveQuiz(false);
            return null;
        }
    }
    // Creating a new array for list of all quizzes for a given page.
    // Passing it down to QuizController.tsx where it's handled.
    let quizList = [];
    try {
        quizList = yield findQuizList(siteId);
        log.debug('Quizzes from targeting', { quizzes });
    }
    catch (e) {
        log.error('Error fetching quizzes', e);
    }
    // swe only use 1st quiz from the set
    const quizData = quizzes[0];
    try {
        const reactRoot = document.createElement('div');
        moduleProps.quizData = quizData;
        moduleProps.isDesktop = isDesktop;
        moduleProps.isDarkTheme = yield isThemeDark();
        moduleProps.trackingConfigs = {
            event: isDesktop ? 'quizConsumption_desktop' : 'quizConsumption_mobile',
            category: 'quiz_consumption',
            quizId: quizData.id,
            skin: isDesktop ? 'fandomdesktop' : 'fandommobile',
        };
        moduleProps.ads = isForced ? ShowAds.Fake : canDisplayAds() ? ShowAds.Yes : ShowAds.No;
        moduleProps.quizList = quizList;
        log.debug('Quiz module ready to be displayed', { moduleProps });
        // API
        const show = () => (reactRoot.style.display = '');
        const hide = () => (reactRoot.style.display = 'none');
        const moduleToRender = isDesktop ? WikiDesktopFeaturedQuizModule : WikiMobileFeaturedQuizModule;
        const render = () => {
            ReactDOM.render(React.createElement(moduleToRender, moduleProps), reactRoot);
        };
        const isInserted = wikiFeaturedQuizPlacementHelper(moduleProps, reactRoot, isForced);
        setPageHaveQuiz(isInserted);
        return isInserted
            ? {
                render,
                show,
                hide,
            }
            : null;
    }
    catch (error) {
        setPageHaveQuiz(false);
        log.debug('QuizConsumptionModule error', error);
    }
    return null;
});
